import { useMutation } from "@tanstack/react-query";
import { MutationOptions } from "./types";
import { SectionRequestDto, updateSection } from "@client";

export function useUpdateSectionMutation(options?: MutationOptions) {
  return useMutation(
    (data: { id: number; input: SectionRequestDto }) =>
      updateSection(data.id, data.input),
    {
      ...options,
      onSuccess: (_, { id }) => {
        options?.onSuccess && options.onSuccess(_, { id });
      },
    },
  );
}
